import { Tooltip } from '@material-ui/core'
import Enlace from 'elements/Enlace/Enlace'
import WrapperLink from 'elements/WrapperLink/WrapperLink'
import { SocketRoles } from '../utils/constants'

const ProfileLink = ({ role, _id, name, info }) => {
  if (role === SocketRoles.TEACHER) {
    return (
      <Tooltip
        placement='bottom-start'
        title={
          <div>
            Alumnos:
            {info.map((studentName, i) => (
              <div key={i}>
                {studentName}
                <br />
              </div>
            ))}
          </div>
        }
      >
        <div>
          <Enlace href='https://core.mundoestudiante.cloud/personal/profesorado'>
            {name}
          </Enlace>
        </div>
      </Tooltip>
    )
  }

  if (role === SocketRoles.STUDENT) {
    return (
      <Tooltip
        placement='bottom-start'
        title={
          <div>
            Profesor:
            <br />
            {info}
          </div>
        }
      >
        <div>
          <WrapperLink to={`/clients/${_id}`}>{name}</WrapperLink>
        </div>
      </Tooltip>
    )
  }

  return <span>--</span>
}

export default ProfileLink
